const MODULE_NAME = 'InstrumentationsModule';

export const GET_INSTRUMENTATIONS = `${MODULE_NAME}/GET_INSTRUMENTATIONS`;
export const GET_INSTRUMENTATIONS_TASK = `${MODULE_NAME}/GET_INSTRUMENTATIONS_TASK`;
export const GET_INSTRUMENTATION_HISTORY = `${MODULE_NAME}/GET_INSTRUMENTATION_HISTORY`;
export const GET_INSTRUMENTATION_JOB_HISTORY = `${MODULE_NAME}/GET_INSTRUMENTATION_JOB_HISTORY`;
export const GET_INSTRUMENTATION_COUNTS_BY_SITE_ID = `${MODULE_NAME}/GET_INSTRUMENTATION_COUNTS_BY_SITE_ID`;
